var site = site || {};

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.nav = {
	// Init navigation scripts
	init: function() {
		// Add expand link to mobile menu
		//$('.children', '#mMenu ').prepend('<a class="expand" href="#"><span>+</span></a>');

		$('.children', '#mainmenu2 ').prepend('<a class="expand" href="#"><span class="fa fa-angle-down"></span></a>');

		$('.selectedLevel1.children, .selectedLevel2.children','#mainmenu2').addClass('down');
		$('.selectedLevel1, .selectedLevel2, .selectedLevel3, .selectedLevel4', '#mainmenu2').find('> a.expand').addClass('down');
		$('.selectedLevel1, .selectedLevel2, .selectedLevel3, .selectedLevel4', '#mainmenu2').find('> ul.menu').addClass('down');

		site.nav.bind();
	},
	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function(e) {
			var menuOpen = $('body').hasClass('mainmenu-open');
			if (!menuOpen) {
			}
			site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
			e.preventDefault();
		});

		// Expand in mobile menu
		$('.expand', '#mainmenu2').bind('click', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $ul = $this.siblings('ul');

			$this.parent().toggleClass('down');
			$ul.toggleClass('hide');
			$this.next().toggleClass('down');
			$this.toggleClass('down');
			e.preventDefault();
		});
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen, scrollPosition) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
		if (!menuOpen) {
			$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
		}
		else {
			$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
		}
	},
	// Append language to mobilemenu
	appendLanguage: function() {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function() {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	}
};

site.nav.initStickyHead = function() {
	window.addEventListener('scroll', function(e){
		var distanceY = window.pageYOffset || document.documentElement.scrollTop,
			shrinkOn = 40;
		if (distanceY > shrinkOn) {
			$('body').addClass('stickyHead');
		} else {
			$('body').removeClass('stickyHead');
		}
	});
};

site.search = {
	tOut: null,

    init: function() {
		$header = $('#header');
		$searchDrop = $('.searchDrop', "#header");
		$body = $('body');
		$gler = $header.find('.gler');

		$gler.click(function () {
			if ($body.hasClass('open-search')) {
				site.search.closeSearch();
			} else {
				$gler.addClass('open');
				$body.addClass('open-search');

				$searchDrop.removeClass('fadeOut hide');
				$searchDrop.addClass('fadeIn');

				$searchDrop.find('#q').focus();
				window.clearTimeout(tOut);
			}

		});

		// Add search to mobile menu
		var $searchForm = $('#searchForm');
		var $menu = $('ul.mmLevel1', '#mainmenu2');
		$menu.prepend($searchForm.clone().wrap("<li class='search'></div>").parent());
	},

	closeSearch: function() {
		$gler.removeClass('open');
		$body.removeClass('open-search');

		$searchDrop.removeClass('fadeIn');
		$searchDrop.addClass('fadeOut');

		tOut = window.setTimeout(function () {
			$searchDrop.addClass('hide');
		}, 1000);
	}
};


// Run all the inits \o/
$(function() {
	site.nav.init();
	site.nav.initStickyHead();
	site.search.init();
	site.owl.init('#hero > ul', {
		stopOnHover: true,
		autoplay: true,
		autoplayTimeout: 12000,
		autoplayHoverPause: true,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		loop:true,
		nav:true,
		dots:true,
		navText:["",""],
		items: 1
	});


	site.owl.init('#adildarfelog > ul', {
		loop:true,
		nav:true,
		margin:10,
		autoplay: true,
		autoplayTimeout: 6000,
		pagination: false,
		dots:false,
		responsive: {
			0: {items:2},
			500: {items:4},
			992: {items:8},
			1400: {items:12}
		},
		navText: [
			"<i class='fa fa-arrow-left'></i>",
			"<i class='fa fa-arrow-right'></i>"
		]
	});

	site.owl.init('#studningur > ul', {
		loop:true,
		nav:true,
		margin:10,
		autoplay: true,
		pagination: false,
		dots:false,
		autoplayTimeout: 6000,
		responsive: {
			0: {items:1},
			500: {items:4},
			992: {items:6},
			1400: {items:6}
		},
		navText: [
			"<i class='fa fa-arrow-left'></i>",
			"<i class='fa fa-arrow-right'></i>"
		]
	});
	site.owl.init('#samstarfsadilar ul', {
		loop:true,
		nav:true,
		margin:30,
		autoplay: true,
		autoplayTimeout: 6000,
		pagination: false,
		dots:false,
		responsive: {
			0: {items:1},
			500: {items:2},
			992: {items:4},
			1500: {items:5}
		}
	});
	site.owl.init('.partners ul', {
		loop:true,
		nav:true,
		margin:30,
		autoplay: true,
		autoplayTimeout: 6000,
		pagination: false,
		dots:false,
		responsive: {
			0: {items:1},
			500: {items:3},
			992: {items:3},
			1400: {items:3}
		}
	});
	site.owl.init('#promoRight > ul', {
		loop:true,
		nav:true,
		margin:30,
		autoplay: true,
		pagination: false,
		dots:false,
		autoplayTimeout: 6000,
		responsive: {
			0: {items:1},
		}
	});
	$('.showMore', "#box_newsheadlines_4").bind('click', function(e) {
		e.preventDefault();
		$menu = $(this).parent().siblings('.menu');
		$menu.toggleClass('open');
		if ($menu.hasClass('open')) {
			$(this).text('Færri fréttir');
		} else {
			$(this).text('Fleiri fréttir');
		}
	});
	$('.showMore', "#box_calendar_eventlist_9").bind('click', function(e) {
		e.preventDefault();
		$menu = $(this).siblings('.menu');
		$menu.toggleClass('open');
		if ($menu.hasClass('open')) {
			$(this).text('Færri viðburðir');
		} else {
			$(this).text('Fleiri viðburðir');
		}
	});
	$('.showMore', "#box_calendar_eventlist_24").bind('click', function(e) {
		e.preventDefault();
		$menu = $(this).siblings('.menu');
		$menu.toggleClass('open');
		if ($menu.hasClass('open')) {
			$(this).text('Færri viðburðir');
		} else {
			$(this).text('Fleiri viðburðir');
		}
	});

	$('.infoWrapper' , '#box_calendar_eventlist_9').click(function(e) {
		location.href= $(this).find('.entryTitle a').attr('href');

	});


	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	$(document).mouseup(function(e) {
		var container = $('.searchDrop');
		var c2 = $('.searchDrop').find('*');
		var openSearch = $('.gler', '#header').find('*');
		if(!container.is(e.target) && !c2.is(e.target) && !openSearch.is(e.target)) {
			site.search.closeSearch();
		}
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
